import LoadingAnimation from '../../../../components/LoadingAnimation';

export function Loading() {
  return (
    <>
      <div className="flex h-full flex-col items-center justify-start gap-32">
        <h1>Loading...</h1>
        <LoadingAnimation />
      </div>
    </>
  );
}
